module.exports = __webpack_public_path__ + "static/images/components/BuildingCardImage/images/cost-bg.8fb960e2.png";


//////////////////
// WEBPACK FOOTER
// ./components/BuildingCardImage/images/cost-bg.png
// module id = 2566
// module chunks = 11